export const activity = [
  {
    path: '/points-center',
    name: 'PointsCenter',
    meta: {
      title: '积分中心'
    },
    component: () => import('../views/points-center/index.vue')
  },
  {
    path: '/points-center/rule',
    name: 'PointsCenterRule',
    meta: {
      title: '活动规则'
    },
    component: () => import('../views/points-center/points-rule.vue')
  },
  {
    path: '/points-center/detail',
    name: 'PointsCenterDetail',
    redirect: {
      name: 'PointsCenterList'
    },
    meta: {
      title: '积分明细'
    },
    component: () => import('../views/points-center/points-detail.vue'),
    children: [
      {
        path: 'list',
        name: 'PointsCenterList',
        meta: {
          title: '积分明细'
        },
        component: () => import('../views/points-center/points-list.vue')
      },
      {
        path: 'use-list',
        name: 'PointsCenterUseList',
        meta: {
          title: '积分明细'
        },
        component: () => import('../views/points-center/points-use-list.vue')
      }, {
        path: 'pass-list',
        name: 'PointsCenterPassList',
        meta: {
          title: '积分明细'
        },
        component: () => import('../views/points-center/points-pass-list.vue')
      }
    ]
  },
  {
    path: '/points-center/records',
    name: 'PointsCenterRecords',
    meta: {
      title: '我的奖品'
    },
    component: () => import(/* webpackChunkName: "PointsCenterRecords" */ '../views/points-center/records.vue')
  },
  {
    path: '/points-center/store',
    name: 'PointsCenterStore',
    meta: {
      title: '积分商城'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/store.vue')
  },
  {
    path: '/points-center/fund-invest',
    name: 'FundInvest',
    meta: {
      title: '投基锦囊'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/fund-invest.vue')
  },
  {
    path: '/points-center/task-fund',
    name: 'TaskFund',
    meta: {
      title: '开启定投之旅'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/task-fund.vue')
  },
  {
    path: '/points-center/jn-rule',
    name: 'JnRule',
    meta: {
      title: '活动规则'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/jn-rule.vue')
  },
  {
    path: '/points-center/awart-log',
    name: 'AwartLog',
    meta: {
      title: '我的获奖记录'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/awart-log.vue')
  },
  {
    path: '/jinqiu',
    name: 'JinQiu',
    meta: {
      title: '挑战正收益'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/jin-qiu.vue')
  },
  {
    path: '/benfu',
    name: 'BenFu',
    meta: {
      title: '理财奔富季'
    },
    component: () => import(/* webpackChunkName: "PointsCenterStore" */ '../views/points-center/ben-fu.vue')
  }
]
